import React from 'react';
import PropertyCard from '../PropertyCard/PropertyCard';
import './FeaturedProperties.css';

function FeaturedProperties() {
  const properties = [
    {
      id: 1,
      images: [
        'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80',
        'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800&q=80',
        'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800&q=80'
      ],
      price: 'PKR 1.5 Crore',
      pricePerSqft: 'PKR 30,000/sq yd',
      title: 'Luxury Villa in DHA',
      location: 'DHA Phase 6, Karachi',
      beds: 5,
      baths: 6,
      area: '500 sq yd',
      type: 'House',
      postedDate: '2 days ago',
      featured: true,
      verified: true
    },
    {
      id: 2,
      images: [
        'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80',
        'https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?w=800&q=80',
        'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800&q=80'
      ],
      price: 'PKR 85 Lac',
      pricePerSqft: 'PKR 4,700/sq ft',
      title: 'Modern Apartment with Amenities',
      location: 'Bahria Town, Lahore',
      beds: 3,
      baths: 3,
      area: '1800 sq ft',
      type: 'Flat',
      postedDate: '5 days ago',
      featured: true,
      verified: true
    },
    {
      id: 3,
      images: [
        'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80',
        'https://images.unsplash.com/photo-1600607687644-c7171b42498b?w=800&q=80',
        'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800&q=80'
      ],
      price: 'PKR 2.2 Crore',
      pricePerSqft: 'PKR 36,600/sq yd',
      title: 'Contemporary House F-7',
      location: 'F-7, Islamabad',
      beds: 6,
      baths: 7,
      area: '600 sq yd',
      type: 'House',
      postedDate: '1 week ago',
      featured: true,
      verified: true
    },
    {
      id: 4,
      images: [
        'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80',
        'https://images.unsplash.com/photo-1600585154084-4e5fe7c39198?w=800&q=80',
        'https://images.unsplash.com/photo-1600573472550-8090b5e0745e?w=800&q=80'
      ],
      price: 'PKR 65 Lac',
      pricePerSqft: 'PKR 5,400/sq ft',
      title: 'Cozy Flat in Gulberg',
      location: 'Gulberg, Lahore',
      beds: 2,
      baths: 2,
      area: '1200 sq ft',
      type: 'Flat',
      postedDate: '3 days ago',
      featured: true,
      verified: false
    },
    {
      id: 5,
      images: [
        'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800&q=80',
        'https://images.unsplash.com/photo-1600585152915-d208bec867a1?w=800&q=80',
        'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800&q=80'
      ],
      price: 'PKR 1.8 Crore',
      pricePerSqft: 'PKR 32,700/sq yd',
      title: 'Spacious Bungalow Clifton',
      location: 'Clifton, Karachi',
      beds: 5,
      baths: 5,
      area: '550 sq yd',
      type: 'Bungalow',
      postedDate: '4 days ago',
      featured: true,
      verified: true
    },
    {
      id: 6,
      images: [
        'https://images.unsplash.com/photo-1600585154363-67eb9e2e2099?w=800&q=80',
        'https://images.unsplash.com/photo-1600566752355-35792bedcfea?w=800&q=80',
        'https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=800&q=80'
      ],
      price: 'PKR 95 Lac',
      pricePerSqft: 'PKR 9,500/Marla',
      title: 'Elegant Residence DHA',
      location: 'DHA Phase 5, Lahore',
      beds: 4,
      baths: 4,
      area: '10 Marla',
      type: 'House',
      postedDate: '6 days ago',
      featured: true,
      verified: true
    },
    {
      id: 7,
      images: [
        'https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_1200,h_800/https://realtoronline.pk/wp-content/uploads/2024/07/125-sqaure-yards-constructed-villa-in-bahria-town-karachi.webp',
        'https://images.unsplash.com/photo-1600047509358-9dc75507daeb?w=800&q=80',
        'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80'
      ],
      price: 'PKR 1.2 Crore',
      pricePerSqft: 'PKR 24,000/Kanal',
      title: 'Premium Villa Bahria Town',
      location: 'Bahria Town, Islamabad',
      beds: 4,
      baths: 5,
      area: '1 Kanal',
      type: 'Villa',
      postedDate: '1 week ago',
      featured: true,
      verified: false
    },
    {
      id: 8,
      images: [
        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQPU23HK97U5sK1KSmdmsNe7XhWcvQKGYVJtA&s',
        'https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=800&q=80',
        'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80'
      ],
      price: 'PKR 75 Lac',
      pricePerSqft: 'PKR 5,000/sq ft',
      title: 'Modern Flat Gulistan-e-Jauhar',
      location: 'Gulistan-e-Jauhar, Karachi',
      beds: 3,
      baths: 3,
      area: '1500 sq ft',
      type: 'Flat',
      postedDate: '5 days ago',
      featured: true,
      verified: true
    }
  ];

  return (
    <section className="featured-properties">
      <div className="container">
        <div className="section-header">
          <h2>Featured Properties</h2>
          <p>Handpicked properties for you</p>
        </div>

        <div className="properties-grid">
          {properties.map(property => (
            <PropertyCard key={property.id} property={property} />
          ))}
        </div>

        <div className="view-all-container">
          <button className="btn-view-all">View All Properties</button>
        </div>
      </div>
    </section>
  );
}

export default FeaturedProperties;
